
module.exports = {    
    BeginInScore: 0,
    BeginOutScore: 1,
    QueryInScore: 2,
    QueryOutScore: 3,
    InScoreDone: 4,
    OutScoreDone: 5
};
